import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async-creatable';
import Select from 'react-select/creatable';
import { ChevronUpSmallIcon, ChevronDownSmallIcon } from '@cognite/cogs-icons';
import { IndicatorSeparator, ClearIndicator } from '../select/select-components.js';
import { TagChip } from '../tag-chip/tag-chip.js';

/**
 * Autocomplete using React-Select. Using same styling as cogs-select.
 */
var AutoComplete = function AutoComplete(_a) {
  var loadOptions = _a.loadOptions,
    handleInputChange = _a.handleInputChange,
    theme = _a.theme,
    styles = _a.styles,
    _a$mode = _a.mode,
    mode = _a$mode === undefined ? 'sync' : _a$mode,
    onCreateOption = _a.onCreateOption,
    _isValidNewOption = _a.isValidNewOption,
    className = _a.className,
    selectComponents = _a.selectComponents,
    rest = __rest(_a, ["loadOptions", "handleInputChange", "theme", "styles", "mode", "onCreateOption", "isValidNewOption", "className", "selectComponents"]);
  // Need to reset React-Select styles in order to override them with .scss
  var customStyles = Object.assign({
    control: function control() {
      return {};
    },
    option: function option() {
      return {};
    },
    multiValueRemove: function multiValueRemove() {
      return {};
    }
  }, styles);
  var formatGroupLabel = function formatGroupLabel(data) {
    return jsxs("div", {
      className: "cogs-v10 cogs-select group-labels",
      children: [jsx("span", {
        children: data.label
      }), jsx(TagChip, {
        colorScheme: "gray",
        size: "x-small",
        label: data.items || data.options.length
      })]
    });
  };
  var DropdownIndicator = function DropdownIndicator(props) {
    var isMenuOpen = props.selectProps.menuIsOpen;
    return components.DropdownIndicator && jsx(components.DropdownIndicator, Object.assign({}, props, {
      children: isMenuOpen ? jsx(ChevronUpSmallIcon, {}) : jsx(ChevronDownSmallIcon, {})
    }));
  };
  var overrideComponents = Object.assign({
    DropdownIndicator: DropdownIndicator,
    IndicatorSeparator: IndicatorSeparator,
    ClearIndicator: ClearIndicator
  }, selectComponents);
  var extendedClassName = ['cogs-v10', 'cogs-select', theme, 'cogs-autocomplete', className].filter(Boolean).join(' ');
  if (mode === 'async') {
    return jsx(AsyncSelect, Object.assign({
      styles: customStyles,
      className: extendedClassName,
      classNamePrefix: "cogs-v10 cogs-select",
      cacheOptions: true,
      loadOptions: loadOptions,
      defaultOptions: true,
      onCreateOption: onCreateOption,
      onInputChange: handleInputChange,
      components: overrideComponents,
      formatGroupLabel: formatGroupLabel,
      onFocus: function onFocus(e) {
        var _a;
        if ((_a = e === null || e === undefined ? undefined : e.target) === null || _a === undefined ? undefined : _a.autocomplete) {
          // eslint-disable-next-line no-param-reassign
          e.target.autocomplete = 'nope';
        }
      },
      isValidNewOption: function isValidNewOption(inputValue) {
        if (!onCreateOption) {
          return false;
        }
        if (_isValidNewOption) {
          return _isValidNewOption(inputValue);
        }
        return true;
      }
    }, rest));
  }
  return jsx(Select, Object.assign({
    styles: customStyles,
    className: extendedClassName,
    classNamePrefix: "cogs-v10 cogs-select",
    onInputChange: handleInputChange,
    onCreateOption: onCreateOption,
    components: overrideComponents,
    formatGroupLabel: formatGroupLabel,
    onFocus: function onFocus(e) {
      if (e.target.autocomplete) {
        // eslint-disable-next-line no-param-reassign
        e.target.autocomplete = 'nope';
      }
    },
    isValidNewOption: function isValidNewOption(inputValue) {
      if (!onCreateOption) {
        return false;
      }
      if (_isValidNewOption) {
        return _isValidNewOption(inputValue);
      }
      return true;
    }
  }, rest));
};

export { AutoComplete };
